<div class="title">
  <h2>DETRAN</h2>
</div>

<div class="card-body">
  <div class="text-span">
    <span class="f-14 fw-500">
      Estamos com instabilidades dos nossos fornecedores em algumas informações
      há alguns dias. Desta forma, para que possamos auxiliar nossos clientes a
      atenderem suas produções de consultas e laudos, criamos esta solução
      paliativa na qual nada interfere na resposta na base instável. O
      processamento continuará normalmente e, tão logo seja possível, será
      atualizado automaticamente em sua consulta.
    </span>
  </div>
  <div class="text-span">
    <span class="f-14 fw-500"> A CONSULTA É GRATUITA E VOCÊ PRECISARÁ DO RENAVAM DO VEÍCULO. </span>
  </div>
  <div style="margin-bottom: 20px;">
    <span class="f-14 fw-500"> Clique abaixo para acessar. </span>
  </div>

  <div class="row no-gutters mt-2">
    <div class="col-12 col-md-6">
      <div class="pt-2 pt-md-0 pl-md-3 w-100">
        <ck-select
          [value]="this.listaEstados[indiceEstadoInicial].value"
          [control]="select"
          [options]="listaEstados"
          [label]="'Local do emplacamento'"
        ></ck-select>
      </div>
      <div class="flex-ac flex-wrap flex-md-nowrap px-3 py-1 bg-white rounded">
        <div class="img-detran-container m-auto">
          <img
            src="./assets/images/detran/{{ select?.value?.Sigla }}.jpg"
            alt="{{ select?.value?.Nome }}"
          />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 pl-3">
      <div class="py-3 py-md-0">
        <div class="mb-2">
          <div class="f-14 fw-500">Você precisa de:</div>
          <span class="">Placa, </span>
          <span class="">Renavam.</span>
        </div>
        <div>
          <div class="f-14 fw-500">Informações disponíveis:</div>
          <span class="">Multas,</span>
          <span class=""> débitos,</span>
          <span class=""> restrições,</span>
          <span class=""> identificação de proprietários.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center">
    <button
      class="mt-3 d-block d-md-inline-block px-5 btn-detran"
      [disabled]="select?.value?.url == null"
      (click)="paginaDetran()"
    >
      <a class="text-white no-text-decoration">ACESSE AQUI</a>
    </button>
  </div>
</div>
